/* Upakarna lightbox (P4b.2, 19 Oct 2026): window.upkLightbox.open(images, index, opener) and click delegation on any
   [data-upk-lightbox] element (the value is the large image URL, 1200 px). Optional: data-upk-lightbox-alt,
   data-upk-lightbox-caption, data-upk-lightbox-group (every element with the same group on the page becomes one gallery,
   with arrows, arrow keys and swipe between them). Escape and a tap outside the image close it; Escape is caught in the
   capture phase so a quick view underneath stays open. The page does not jump: the html overflow is locked and then
   restored to whatever it was (the quick view keeps its own lock), the scroll position is untouched. Focus returns to
   the opener. */
(function () {
  'use strict';
  if (window.upkLightbox) return;
  var box = null, img = null, cap = null, prev = null, next = null, count = null;
  var images = [], index = 0, opener = null, prevOverflow = null, open = false;
  var swallowEscapeUp = false; /* Dawn's drawers and modals close on the Escape key-up, so the key-up that follows the key-down which closed the lightbox is swallowed too */

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'upk-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Enlarged image');
    box.innerHTML = '<figure class="upk-lb__fig"><img class="upk-lb__img" alt=""><figcaption class="upk-lb__cap"></figcaption></figure>' +
      '<button type="button" class="upk-lb__btn upk-lb__x" aria-label="Close">&times;</button>' +
      '<button type="button" class="upk-lb__btn upk-lb__prev" aria-label="Previous image" hidden>&#8249;</button>' +
      '<button type="button" class="upk-lb__btn upk-lb__next" aria-label="Next image" hidden>&#8250;</button>' +
      '<span class="upk-lb__count" aria-live="polite"></span>';
    document.body.appendChild(box);
    img = box.querySelector('.upk-lb__img');
    cap = box.querySelector('.upk-lb__cap');
    prev = box.querySelector('.upk-lb__prev');
    next = box.querySelector('.upk-lb__next');
    count = box.querySelector('.upk-lb__count');
    box.querySelector('.upk-lb__x').addEventListener('click', function (e) { e.stopPropagation(); close(); });
    prev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    next.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('upk-lb__fig')) close(); });
    var sx = null, sy = null;
    box.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0]; var dx = t.clientX - sx, dy = t.clientY - sy; sx = sy = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  function show() {
    var it = images[index];
    if (!it) return;
    img.src = it.src;
    img.alt = it.alt || '';
    cap.textContent = it.caption || '';
    var many = images.length > 1;
    prev.hidden = !many;
    next.hidden = !many;
    count.textContent = many ? (index + 1) + ' / ' + images.length : '';
  }
  function go(d) {
    if (images.length < 2) return;
    index = (index + d + images.length) % images.length;
    show();
  }
  function openLb(list, i, from) {
    build();
    images = (list || []).filter(function (x) { return x && x.src; });
    if (!images.length) return;
    index = Math.max(0, Math.min(i || 0, images.length - 1));
    opener = from || document.activeElement;
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.classList.add('upk-lb-lock');
    box.classList.add('is-open');
    open = true;
    show();
    try { box.querySelector('.upk-lb__x').focus({ preventScroll: true }); } catch (e) {}
  }
  function close() {
    if (!open) return;
    box.classList.remove('is-open');
    open = false;
    document.documentElement.classList.remove('upk-lb-lock');
    if (prevOverflow !== null) document.documentElement.style.overflow = prevOverflow;
    img.removeAttribute('src');
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    opener = null;
  }
  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    if (open || swallowEscapeUp) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
    swallowEscapeUp = false;
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); swallowEscapeUp = true; close(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
  }, true);
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-upk-lightbox]') : null;
    if (!el) return;
    var src = el.getAttribute('data-upk-lightbox');
    if (!src) return;
    e.preventDefault();
    var group = el.getAttribute('data-upk-lightbox-group');
    var list, i = 0;
    if (group) {
      var els = Array.prototype.slice.call(document.querySelectorAll('[data-upk-lightbox-group="' + group + '"]'));
      list = els.map(function (x) { return { src: x.getAttribute('data-upk-lightbox'), alt: x.getAttribute('data-upk-lightbox-alt') || '', caption: x.getAttribute('data-upk-lightbox-caption') || '' }; });
      i = els.indexOf(el);
    } else {
      list = [{ src: src, alt: el.getAttribute('data-upk-lightbox-alt') || '', caption: el.getAttribute('data-upk-lightbox-caption') || '' }];
    }
    openLb(list, i, el);
  }, true);
  window.upkLightbox = { open: openLb, close: close, isOpen: function () { return open; } };
})();
